import React from "react";
import { Helmet } from "react-helmet";
import Navbar from "../components/layout/Navbar";
import Hero from "../components/sections/Hero";
import AboutCompany from "../components/sections/AboutCompany";
import Services from "../components/sections/Services";
import Testimonials from "../components/sections/Testimonials";
import Contact from "../components/sections/Contact";
import Footer from "../components/layout/Footer";
import ScrollTop from "../components/common/ScrollTop";

const Home = () => {
  return (
    <>
      <Helmet>
        <title>SAINI COLLECTION | IT Services</title>
        <meta
          name="description"
          content="Professional IT services and web development solutions. We build modern websites, custom digital tools, and provide comprehensive IT services to grow your business."
        />
        <meta
          name="keywords"
          content="IT services, web development, website design, custom software, digital solutions, frontend development, backend development"
        />
        <meta
          property="og:title"
          content="SAINI COLLECTION | IT Services & Web Development Solutions"
        />
        <meta
          property="og:description"
          content="Professional IT services and web development solutions for businesses and individuals."
        />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://www.sainicollection.com/" />
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap"
          rel="stylesheet"
        />
      </Helmet>

      <Navbar />
      <main>
        <Hero />
        <AboutCompany />
        <Services />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <ScrollTop />
    </>
  );
};

export default Home;
